// extracted by mini-css-extract-plugin
export var contrastLow = "_3l-1";
export var externalLink = "_3l-2";
export var externalLinkIcon = "_3l-3";
export var link = "_3l-0";
export var linkLabel = "_3l-4";